import craftSans700otf from './CraftSans-Bold.otf';
import craftSans300otf from './CraftSans-Light.otf';
import craftSans400otf from './CraftSans-Regular.otf';

const craftSansSrc = {
  400: {
    woff: undefined,
    woff2: undefined,
    ttf: undefined,
    otf: craftSans300otf,
  },
  500: {
    woff: undefined,
    woff2: undefined,
    ttf: undefined,
    otf: craftSans400otf,
  },
  700: {
    woff: undefined,
    woff2: undefined,
    ttf: undefined,
    otf: craftSans700otf,
  },
};

export { craftSansSrc };
